import styled from 'styled-components'

export const DatapointSelectorContainerStyled = styled.div``
